import React, {useEffect, useState} from "react";
import {Link, useLocation, useNavigate} from "react-router";
import {onLogout} from "../utils/commonData";
import {useUserContext} from "../context/UserContext";
import { Settings, Users } from "lucide-react";
import WaitingRoom from "./WaitingRoom";
import Assistant from "./Assistant";
import {useUnreadMessagesCount, useUnreadMessagesRealtimeSync} from "../queries/useUnreadMessagesQuery";
import { useCollaborations, useCollaborationRealtime } from "../features/collaboration/hooks/useCollaborationQueries";
import "../features/collaboration/collaboration.css";

import Logo from "../assets/images/sidebar-logo.svg";
import icon1 from "../assets/images/dashboard-icon.svg";
import icon2 from "../assets/images/appoinment-icon.svg";
import icon3 from "../assets/images/availability-icon.svg";
import icon4 from "../assets/images/documents-icon.svg";
import icon5 from "../assets/images/message-icon.svg";
import icon6 from "../assets/images/nurse-icon.svg";
import icon7 from "../assets/images/logout-icon.svg";
import arrowIcon from "../assets/images/Arrow-2.png";
import {Menu, X} from "lucide-react";
const Header = () => {
  const {
    userData, 
    setUserData, 
    isActiveDocAcc, 
    sidebarDrawerOpen, 
    setSidebarDrawerOpen,
  } = useUserContext();

  const navigate = useNavigate();
  const location = useLocation();
  const [isLoaded, setIsLoaded] = useState(false);
  const [toggle, setIsToggle] = useState(false);
  const isDoctor = userData?.users?.type === "Doctor";
  const collaborations = useCollaborations({ enabled: isDoctor && Boolean(isActiveDocAcc) });
  useCollaborationRealtime(isDoctor ? userData?.users?.id : null);
  const pendingCollaborations = collaborations.data?.pending || [];

  // Unread message count shown next to "Messages" in the sidebar (doctor only —
  // see the Nurse branch below, which has no Messages entry).
  const doctorId = userData?.users?.type === "Nurse" ? null : userData?.users?.id;
  const {data: unreadMessagesCount, refetch: refetchUnreadMessages} =
    useUnreadMessagesCount(doctorId);
  useUnreadMessagesRealtimeSync(doctorId);

  // Refresh right away when leaving the Messages page (conversations just read
  // there should stop counting immediately instead of waiting for the poll).
  useEffect(() => {
    if (doctorId && location.pathname !== "/doctor/messages") {
      refetchUnreadMessages();
    }
  }, [location.pathname, doctorId, refetchUnreadMessages]);

  const handleImageLoad = () => {
    // Set the loaded state to true when the image finishes loading
    setIsLoaded(true);
  };

  const handleLogout = () => {
    onLogout();
    setUserData(null);
    navigate("/");
  };

  return (
    <div className={`sideMain ${toggle ? "navClose" : ""}  ${sidebarDrawerOpen ? "openSideMenu" : ""}`}>
      <div className="sidebarDiv" onClick={() => setSidebarDrawerOpen(false)}>
        <div className="logoSide">
          <button className="hamburger_menu" onClick={() => setSidebarDrawerOpen(!sidebarDrawerOpen)}>
            {sidebarDrawerOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
          <Link to={`${userData ? "/doctor/dashboard/" : "/"}`}>
            {/* <img src={Logo} alt="Logo" className={isLoaded ? "rotate" : ""} onLoad={handleImageLoad} /> */}
            <img src={Logo} alt="Logo" />
          </Link>
        </div>

        {userData?.users?.type === "Nurse" ? (
          <ul className="sidebarList">
            <li className={location.pathname === "/nurse/appointments" ? "active" : ""}>
              <Link to={"/nurse/appointments"}>
                {/* <Link> */}
                <div className="iconDiv">
                  <img src={icon2} alt="icon2" />
                </div>
                <span>Appointments</span>
              </Link>
            </li>
            <div className="sidebar-bottom-section">
              <ul className="bottom-items-list">
                {/* Waiting Room Component */}
                <WaitingRoom />

                {/* Assistant Component */}
                <Assistant />

                <li className="doctorLogout">
                  <Link to={"javascript:void(0);"} onClick={() => handleLogout()}>
                    <div className="iconDiv">
                      <img src={icon7} alt="icon7" />
                    </div>
                    <span>Logout</span>
                  </Link>
                </li>
              </ul>
            </div>
            {/* <li className="doctorLogout">
              <Link to={"javascript:void(0);"} onClick={() => handleLogout()}>
                <div className="iconDiv">
                  <img src={icon7} alt="icon7" />
                </div>
                <span>Logout</span>
              </Link>
            </li> */}
            {/* <span className="closeSidebar" onClick={() => setIsToggle(!toggle)}>
     <img src={arrowIcon} alt="icon7" />
   </span> */}
          </ul>
        ) : (
          <>
            <ul className="sidebarList">
              <li className={location.pathname === "/doctor/dashboard" ? "active" : ""}>
                <Link to={isActiveDocAcc ? "/doctor/dashboard" : "/doctor/incomplete-profile"}>
                  <div className="iconDiv">
                    <img src={icon1} alt="icon1" />
                  </div>
                  <span>Dashboard</span>
                </Link>
              </li>
              <li className={location.pathname === "/doctor/appointments" ? "active" : ""}>
                <Link to={isActiveDocAcc ? "/doctor/appointments" : "/doctor/incomplete-profile"}>
                  {/* <Link> */}
                  <div className="iconDiv">
                    <img src={icon2} alt="icon2" />
                  </div>
                  <span>Appointments</span>
                </Link>
              </li>
              <li className={location.pathname === "/doctor/availability" ? "active" : ""}>
                {/* <Link> */}
                <Link to={isActiveDocAcc ? "/doctor/availability" : "/doctor/incomplete-profile"}>
                  <div className="iconDiv">
                    <img src={icon3} alt="icon3" />
                  </div>
                  <span>Availability</span>
                </Link>
              </li>
              {/* <li>
                <Link>
                  <div className="iconDiv">
                    <img src={icon4} alt="icon4" />
                  </div>
                  <span>Documents</span>
                </Link>
              </li> */}
              <li className={location.pathname === "/doctor/messages" ? "active" : ""}>
                <Link to={isActiveDocAcc ? "/doctor/messages" : "/doctor/incomplete-profile"}>
                  <div className="iconDiv">
                    <img src={icon5} alt="icon5" />
                  </div>
                  <span>Messages</span>
                  {unreadMessagesCount > 0 && (
                    <span className="sidebar-unread-badge">{unreadMessagesCount}</span>
                  )}
                </Link>
              </li>
              <li className={location.pathname === "/doctor/nurses" ? "active" : ""}>
                {/* <Link> */}
                <Link to={isActiveDocAcc ? "/doctor/nurses" : "/doctor/incomplete-profile"}>
                  <div className="iconDiv">
                    <img src={icon6} alt="icon6" />
                  </div>
                  <span>Nurse</span>
                </Link>
              </li>

              <li className={`collaboration-sidebar-item ${location.pathname === "/doctor/collaboration" ? "active" : ""}`}>
                <Link to={isActiveDocAcc ? "/doctor/collaboration" : "/doctor/incomplete-profile"}>
                  <div className="iconDiv"><Users size={20} /></div>
                  <span>Collaboration</span>
                </Link>
                {pendingCollaborations.length > 0 && (
                  <details className="collaboration-sidebar-details">
                    <summary className="collaboration-sidebar-badge" aria-label={`${pendingCollaborations.length} pending collaboration invitations`}>{pendingCollaborations.length}</summary>
                    <div className="collaboration-sidebar-preview" role="status">
                      <strong>Pending invitations</strong>
                      {pendingCollaborations.slice(0, 3).map((item) => <span key={item.id}>{item.patient?.name || 'Patient'}</span>)}
                    </div>
                  </details>
                )}
              </li>

              <li className={location.pathname === "/doctor/configuration" ? "active" : ""}>
                <Link to={isActiveDocAcc ? "/doctor/configuration" : "/doctor/incomplete-profile"}>
                  <div className="iconDiv">
                    <Settings size={20} />
                  </div>
                  <span>Configuration</span>
                </Link>
              </li>
            </ul>

            {/* Bottom Section */}
            <div className="sidebar-bottom-section">
              <ul className="bottom-items-list">
                {/* Waiting Room Component */}
                <WaitingRoom />

                {/* Assistant Component */}
                <Assistant />

                <li className="doctorLogout">
                  <Link to={"javascript:void(0);"} onClick={() => handleLogout()}>
                    <div className="iconDiv">
                      <img src={icon7} alt="icon7" />
                    </div>
                    <span>Logout</span>
                  </Link>
                </li>
              </ul>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Header;
